module.exports = __webpack_public_path__ + "img/thumbnail_Binturong_j_normal.f17598d8.png";